module.exports = __webpack_public_path__ + "static/media/Logo.a50854a5.jpeg";